import { UserDto, UserRoles } from '../api/tenant/models/UserDto'
import Cookies from 'js-cookie'

export class AuthHelper {
    public static setTenantOverrideId(tenantOverrideId: string): void {
        Cookies.set('tenantOverrideId', tenantOverrideId, { expires: 730 }) // Expires in ~2 years (730 days)
    }

    public static getTenantOverrideId(): string | undefined {
        const tenantOverrideId = Cookies.get('tenantOverrideId')
        if (!tenantOverrideId) {
            return undefined
        } else {
            return tenantOverrideId
        }
    }

    public static removeTenantOverrideId() {
        Cookies.remove('tenantOverrideId')
    }

    public static userHasRoleForTenant(
        user: UserDto,
        role: UserRoles,
        tenantId: string,
    ): boolean {
        if (user.isProductAdmin) {
            return true
        }

        const membershipForTenant = user.memberships.find((membership) => {
            return membership.tenantId === tenantId
        })

        if (!membershipForTenant) {
            return false
        }

        return membershipForTenant.roles.includes(role)
    }

    public static userHasSomeRolesForTenant(
        user: UserDto,
        roles: UserRoles[],
        tenantId: string,
    ): boolean {
        if (user.isProductAdmin) {
            return true
        }

        const membershipForTenant = user.memberships.find((membership) => {
            return membership.tenantId === tenantId
        })

        if (!membershipForTenant) {
            return false
        }

        return roles.some((role) => membershipForTenant.roles.includes(role))
    }
}
